<script lang="ts" setup>
import type { PartnerKey, PartnerImage } from '@csm/template/components/CsmUiPartners'
import chwZoryImage from '@/assets/logos/chw-zory.svg?raw'
import kcSosnowiecImage from '@/assets/logos/kc-sosnowiec.svg?raw'
import kchbGdyniaImage from '@/assets/logos/kchb-gdynia.svg?raw'
import kzBetaniaKatowiceImage from '@/assets/logos/kz-betania-katowice.svg?raw'
import kzRadoscGdanskImage from '@/assets/logos/kz-radosc-gdansk.svg?raw'
import malinkaImage from '@/assets/logos/malinka.svg?raw'
import kjchKrakowImage from '@/assets/logos/kjch-krakow.svg?raw'

const partners: (PartnerKey | PartnerImage)[] = [
  'schpolnoc',
  {
    name: 'Kościół Zielonoświątkowy "Betania"',
    src: kzBetaniaKatowiceImage,
    href: 'https://betania-katowice.org',
    style: {
      maxWidth: '90px',
      paddingBottom: '6px',
    }
  },
  {
    name: 'Kościół Zielonoświątkowy "Radość"',
    src: kzRadoscGdanskImage,
    href: 'https://radosckosciol.org',
    style: {
      maxWidth: '80px',
    },
  },
  {
    name: 'Malinka',
    src: malinkaImage,
    href: 'https://malinka.org.pl',
    style: {
      maxWidth: '84px',
    }
  },
  {
    name: 'Chrześcijańska Wspólnota Żory',
    src: chwZoryImage,
    href: 'https://chwzory.pl',
    style: {
      maxWidth: '90px',
    }
  },
  {
    name: 'Społeczność Chrześcijańska „Radosna" w Sosnowcu',
    src: kcSosnowiecImage,
    href: 'http://spolecznosc-sosnowiec.pl/',
    style: {
      maxWidth: '46px',
    }
  },
  {
    name: 'Kościół Chrześcijan Baptystów w Gdyni',
    src: kchbGdyniaImage,
    href: 'https://baptyscigdynia.pl',
    style: {
      maxWidth: '84px',
    }
  },
  {
    name: 'Kościół Jezusa Chrystusa w Krakowie',
    src: kjchKrakowImage,
    href: 'https://www.kjch.pl/',
    style: {
      maxWidth: '84px',
    }
  },
  'filadelfia',
]
</script>

<template>
  <csm-ui-partners
    :value="partners"
    :opacity=".25"
    class="my-4"
  />

  <div
    class="d-flex flex-column align-center justify-center ga-8 my-10"
    :style="{ maxWidth: '550px'}"
  >
    <v-chip
      color="gray-300"
      variant="outlined"
      text="Łączy nas misja"
    />
    <div class="text-h5 font-weight-regular text-center">
      CSM/online pomaga już 1000+ użytkownikom i 100+ zespołom ze wspólnot w Polsce i za granicą.
    </div>
  </div>

  <csm-ui-partners
    :value="partners"
    :opacity=".25"
    class="my-4"
  />
</template>
